import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Providers from "./pages/Providers";
import Preceptorship from "./pages/Preceptorship";
import Contact from "./pages/Contact";
import SlidingFee from "./pages/SlidingFee";
import StaffApplications from "./pages/StaffApplications";
import { AuthCallback } from "./components/staff/AuthCallback";
import { Toaster } from "./components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/providers" element={<Providers />} />
      <Route path="/preceptorship" element={<Preceptorship />} />
      <Route path="/sliding-fee" element={<SlidingFee />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/staff" element={<StaffApplications />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <AppRouter />
        <Footer />
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
